import React from 'react';
import { useBrandingContext } from '../../contexts/BrandingContext';

type PageHeadingProps = {
	children: React.ReactNode;
	/** Optional. When provided, sets document.title to `${title} – {appName}`. */
	title?: string;
	/** If true, focus the heading on mount for screen readers/keyboard users. */
	autoFocus?: boolean;
};

export function PageHeading({ children, title, autoFocus = true }: PageHeadingProps) {
	const ref = React.useRef<HTMLHeadingElement | null>(null);
	const { config: branding } = useBrandingContext();

	React.useEffect(() => {
		if (title) {
			try {
				const appName = branding?.appName || 'Experience';
				document.title = `${title} – ${appName}`;
			} catch {}
		}
		if (autoFocus && ref.current) {
			ref.current.focus();
		}
	}, [title, autoFocus, branding]);

	return (
		<h1 ref={ref} tabIndex={-1} style={{ margin: 0 }}>
			{children}
		</h1>
	);
}

export default PageHeading;


